import { Action } from '..';
import { IdDict, listToIdDict } from '../../../shared/idDict';
import { EventType } from '../../../shared/types';

export interface Event {
    id: number;
    type: EventType;
    start: Date;
    end: Date | null;
    label: string;
    subLabel: string | null;
    url: string;
}

export interface CalendarState {
    events: {
        ids: number[];
        dict: IdDict<Event>;
    };
    selectedDate: Date | null;
    selectedMonth: Date | null;
}

const initialState: CalendarState = {
    events: {
        ids: [],
        dict: {},
    },
    selectedDate: new Date(),
    selectedMonth: new Date(),
};

export function reducer(state: CalendarState = initialState, action: Action): CalendarState {
    switch (action.type) {
        case 'LOAD_CALENDAR_DATA':
            return {
                ...state,
                events: {
                    ids: action.events.map(e => e.id),
                    dict: listToIdDict(action.events),
                },
            };
        case 'CALENDAR_SELECT_DAY':
            return {
                ...state,
                selectedDate: action.day,
            };
        case 'CALENDAR_SELECT_MONTH':
            return {
                ...state,
                selectedMonth: action.month,
            };
        default:
            return state;
    }
}
